import PropTypes from "prop-types";
import React from "react";
import {
    Icon,
    Label,
} from "semantic-ui-react";

const Counters = ({
                      n: num,
                      delta = false,
                      className,
                      onClick,
                  }) => {
    const n = typeof num === "string" ? parseInt(num, 10) : num;
    const text = delta && n > 0 ? `+${n}` : n;
    let cs = <Label circular
                    color="orange"
                    basic={delta}
                    as="span"
                    className={className}>
        <Icon name="database" />
        {text}
    </Label>;
    if (onClick) {
        cs = <button onClick={onClick} style={{
            borderWidth: 0,
            backgroundColor: "inherit",
        }}>{cs}</button>;
    }
    return cs;
};

Counters.propTypes = {
    n: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    delta: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
};

export default Counters;



// WEBPACK FOOTER //
// ./src/util/Counters.js